import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    height: "100%",
  },
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  headerText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    color: "#272525",
  },
  listBox: {
    borderRadius: "14px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically ✅
    textAlign: "center",
    height: "100%", // Must have a height to vertically center!
    minHeight: "300px", // Optional: force a height so centering works
    width: "100%",
  },
}));

export default useStyles;
